import { render, staticRenderFns } from "./muokkausoikeudet.vue?vue&type=template&id=fd462afc&scoped=true&"
import script from "./muokkausoikeudet.vue?vue&type=script&lang=ts&"
export * from "./muokkausoikeudet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd462afc",
  null
  
)

export default component.exports